import { render } from "./ListBans.vue?vue&type=template&id=43e48268&ts=true"
import script from "./ListBans.vue?vue&type=script&lang=ts"
export * from "./ListBans.vue?vue&type=script&lang=ts"

import exportComponent from "/home/webchat/thelounge-lfnet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__